import { NIM } from '@yxim/nim-web-sdk/dist/SDK/NIM_Web_NIM';
import { getLeYanBotHost } from 'services/api/leyanBotHost';
import { isNimConnected } from 'services/nim/nimitt';

function createWorker(fnStr: string) {
  const blob = new Blob([`${fnStr}`], {
    type: 'text/javascript',
  });
  const url = URL.createObjectURL(blob);
  return new Worker(url);
}

let currentWorker: Worker | null = null;

export function stopHeartbeat() {
  if (!currentWorker) {
    return;
  }
  try {
    currentWorker.terminate();
  } catch {
    // ignore
  } finally {
    currentWorker = null;
  }
}

export default function beginHearbeat(nimInstance: NIM | null) {
  // 防止被重复调用时堆积多个 Worker
  stopHeartbeat();

  const leyanbotHost = getLeYanBotHost();
  const url = `${leyanbotHost}/oversea-nim/heartbeat`;
  const token = sessionStorage.getItem('@fett-token') || localStorage.getItem('@fett-token');

  const heartbeatWorker = createWorker(`self.onmessage = () => {
    let lastTime = Date.now();
    // 仅用于检测“长时间卡住后唤醒重连”，无需 1s 级频率
    let checkInterval = 5 * 1000;
    setInterval(function () {
        const currentTime = Date.now();
        const duration = currentTime - lastTime
        if (duration > checkInterval * 2  ) {  // ignore small delays
            console.info('duration timeover <%s>ms', duration)
            postMessage({type: "wakeup", lastTime, currentTime});
        }
        lastTime = currentTime;
    }, checkInterval);
    setInterval(() => {
      fetch('${url}', {
        method: 'POST',
        mode: 'cors',
        headers: {
          authorization:
            'Bearer ${token}',
        },
      }).catch(() => {});
    }, 30 * 1000);
  }`);

  heartbeatWorker.postMessage('hearBeat!');

  heartbeatWorker.addEventListener('message', (e) => {
    if (e?.data?.type === 'wakeup') {
      const connected = isNimConnected();
      if (!connected && nimInstance) {
        nimInstance.connect();
      }
    }
  });

  currentWorker = heartbeatWorker;

  // 兜底：页面退出时终止 worker（Electron/浏览器都适用）
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeunload', stopHeartbeat, { once: true });
  }
  return heartbeatWorker;
}
